import { LAYOUT } from '../constants'

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export default [
    {
        path: '/alumniAssociation',
        component: LAYOUT,
        redirect: '/alumniAssociation/introduct',
        meta: { title: '校友总会', showNavPanel: true },
        children: [
            {
                path: 'introduct',
                name: '总会介绍',
                component: () => import('@/views/alumniAssociation/introduct.vue'),
                meta: { title: '总会介绍' },
            },
            // {
            //     path: 'speak',
            //     name: '会长致辞',
            //     component: () => import('@/views/alumniAssociation/speak.vue'),
            //     meta: { title: '会长致辞' },
            // },
            {
                path: 'rules',
                name: '总会章程',
                component: () => import('@/views/alumniAssociation/rules.vue'),
                meta: { title: '总会章程' },
            },
            {
                path: 'nameList',
                name: '理事会名单',
                component: () => import('@/views/alumniAssociation/nameList.vue'),
                meta: { title: '理事会名单' },
            },
            {
                path: 'laws',
                name: '制度法规',
                component: () => import('@/views/alumniAssociation/laws.vue'),
                meta: { title: '制度法规' },
            },
            {
                path: 'aboutUs',
                name: '联系我们',
                component: () => import('@/views/alumniAssociation/aboutUs.vue'),
                meta: { title: '联系我们' },
            },
        ],
    },
]
